import { ICandidateStatusDefinition } from "../../Typings/CandidateStatus";
import { CANDIDATE_STATUS_DEFAULTS } from "./statusDefaults";

export const getStatusTooltip = (
  statusColor: string,
  definitions: ICandidateStatusDefinition[] | undefined,
): string => {
  const source = definitions && definitions.length ? definitions : CANDIDATE_STATUS_DEFAULTS;
  const definition = source.find((d) => d.color === statusColor);
  if (!definition) {
    return statusColor;
  }
  const description = definition.description?.trim();
  return description ? `${definition.label} - ${description}` : definition.label;
};
